var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.110748,
    width: 48.3127,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1645 29.0798C17.2196 29.0798 11.3597 30.2073 11.3597 34.5588C11.3597 38.9121 17.2574 40 24.1645 40C31.1094 40 36.9693 38.8725 36.9693 34.521C36.9693 30.1677 31.0716 29.0798 24.1645 29.0798Z",
    fill: "#306BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.1645 24.9341C28.8671 24.9341 32.6379 21.1661 32.6379 16.467C32.6379 11.7661 28.8671 8 24.1645 8C19.4618 8 15.6911 11.7661 15.6911 16.467C15.6911 21.1661 19.4618 24.9341 24.1645 24.9341Z",
    fill: "#306BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.5614 18.4386C43.7781 13.6836 40.211 9.41321 35.6688 9.41321C35.1749 9.41321 34.7027 9.46724 34.2412 9.5591C34.1799 9.57351 34.1114 9.60413 34.0754 9.65816C34.0339 9.7266 34.0646 9.81846 34.1096 9.87789C35.4741 11.7907 36.2582 14.1195 36.2582 16.6195C36.2582 19.0149 35.539 21.2483 34.2773 23.1017C34.1475 23.2926 34.2628 23.5501 34.4918 23.5898C34.809 23.6456 35.1334 23.6744 35.4651 23.6834C38.7726 23.7699 41.7413 21.6428 42.5614 18.4386Z",
    fill: "#306BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0265 29.6339C45.4209 28.3443 43.9591 27.46 41.7366 27.0259C40.6876 26.7701 37.8487 26.4099 35.2081 26.4586C35.1684 26.464 35.1468 26.491 35.1432 26.509C35.1378 26.5342 35.1486 26.5774 35.2009 26.6044C36.4211 27.2078 41.1382 29.832 40.5452 35.3669C40.5199 35.6064 40.7128 35.8135 40.9525 35.7775C42.1133 35.6118 45.1 34.9706 46.0265 32.9732C46.5384 31.9177 46.5384 30.6912 46.0265 29.6339Z",
    fill: "#306BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.2922 9.55959C13.8325 9.46593 13.3585 9.4137 12.8646 9.4137C8.32239 9.4137 4.7553 13.6841 5.97377 18.4391C6.79209 21.6432 9.76076 23.7704 13.0683 23.6839C13.4 23.6749 13.7262 23.6443 14.0416 23.5903C14.2705 23.5506 14.3859 23.2931 14.2561 23.1021C12.9944 21.247 12.2752 19.0154 12.2752 16.6199C12.2752 14.1182 13.0611 11.7894 14.4256 9.87838C14.4688 9.81895 14.5013 9.72709 14.458 9.65865C14.422 9.60281 14.3553 9.574 14.2922 9.55959Z",
    fill: "#306BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79714 27.0253C4.57469 27.4593 3.11469 28.3437 2.50906 29.6333C1.99535 30.6905 1.99535 31.9171 2.50906 32.9744C3.43553 34.97 6.42222 35.613 7.58302 35.7769C7.82274 35.8129 8.01381 35.6076 7.98857 35.3662C7.39556 29.8332 12.1126 27.209 13.3347 26.6056C13.3852 26.5768 13.396 26.5354 13.3906 26.5084C13.387 26.4903 13.3671 26.4633 13.3275 26.4597C10.6851 26.4093 7.84798 26.7695 6.79714 27.0253Z",
    fill: "#306BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsGroup);
export default __webpack_public_path__ + "static/media/ClientsGroup.40b151dd419d91d07c9f7535f03fab2f.svg";
export { ForwardRef as ReactComponent };